import { hydrateWhenVisible } from 'vue-lazy-hydration'
import PageHomepage from 'themes/base/components/shop/PageHomepage'
import ShopCertificates from '@theme/components/shop/ShopCertificates'
import isEmpty from 'lodash/isEmpty'

const DiscountsOverview = () => import('@theme/components/content/DiscountsOverview')
const TabSwitch = () => import('@theme/components/shop/TabSwitch')

export default {
  mixins: [PageHomepage],
  components: {
    DiscountsOverview: hydrateWhenVisible(DiscountsOverview),
    TabSwitch: hydrateWhenVisible(TabSwitch),
    ShopCertificates,
  },
  data() {
    return {
      productSections: {
        value: null,
      },
    }
  },
  created() {
    this.productSections.value = this.productBoxSections[0]?.value
  },
  computed: {
    criticalContentBreakpoints() {
      return [{ viewportMinWidth: 320, imageWidth: 255, imageHeight: 270 }]
    },
    criticalContentImageSettings() {
      return {
        crop: false,
        webP: true,
      }
    },
    criticalContentPaths() {
      const elements = []

      if (this.featuredProducts.saledProducts && this.featuredProducts.saledProducts.length > 0) {
        // Only the first one is above the fold on mobile; more preloads compete with it for bandwidth
        const products = this.featuredProducts.saledProducts.slice(0, 1)
        for (const product of products) {
          elements.push(product.mainImage)
        }
      }

      return elements
    },
    productBoxSections() {
      const sections = []

      if (this.featuredProducts.saledProducts && !isEmpty(this.featuredProducts.saledProducts)) {
        sections.push({ title: this.$t('Homepage.products.saled.heading'), value: 'saledProducts' })
      }

      if (this.featuredProducts.mostSoldProducts && !isEmpty(this.featuredProducts.mostSoldProducts)) {
        sections.push({ title: this.$t('Homepage.products.featured.heading'), value: 'mostSoldProducts' })
      }

      if (this.featuredProducts.newestProducts && !isEmpty(this.featuredProducts.newestProducts)) {
        sections.push({ title: this.$t('Homepage.products.newest.heading'), value: 'newestProducts' })
      }

      return sections
    },
  },
}
